import { Field, InputType, Int } from '@nestjs/graphql'

@InputType()
export class CategoryIdInput {
  @Field(t => Int)
  id!: number
}

